import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { API_BASE_URL } from "../../utils/apiUrl";
import AboutSection from "./sections/AboutSection";
import CareerSection from "./sections/CareerSection";
import MediaSection from "./sections/MediaSection";
import ReferralSection from "./sections/ReferralSection";
import { updateUserProfile } from "../../utils/userApi";
import StatusModal from "../../components/modals/statusModal/StatusModal";
import "./AccountPage.css";
import { useLocation } from "react-router-dom";
import BadgePanel from "../../components/badgeList/BadgePanel";
import { getImageSrc } from "../../utils/getImageSrc";

const ProfileTab = ({ setStatusModal, initialTab }) => {
  const { user, updateUser, refreshUser } = useAuth();
  const location = useLocation();

  console.log("user", user);

  const [activeTab, setActiveTab] = useState("about");
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isEditingImage, setIsEditingImage] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  // const [statusModal, setStatusModal] = useState({
  //   open: false,
  //   type: "success", // success | error
  //   message: "",
  //   subtext: "",
  // });

  // console.log("updateUser", user);
  useEffect(() => {
    if (location.hash === "#referral") {
      setActiveTab("referral");
    }
  }, [location]);

  useEffect(() => {
    if (initialTab) setActiveTab(initialTab);
  }, [initialTab]);

  useEffect(() => {
    refreshUser();
  }, []);

  // const avatarSrc = preview
  //   ? preview
  //   : user?.picture?.url
  //     ? `${API_BASE_URL}${user.picture.url}`
  //     : "/images/avatar2.png";

  const avatarSrc = getImageSrc(user?.picture);

  const userIdentity =
    user?.role === "tutor"
      ? user?.tutorId
      : user?.role === "institution"
        ? user?.centerId
        : "Student";

  const tabs =
    user?.role === "student"
      ? ["about"]
      : ["about", "career", "media", "referral"];

  const tabLabels = {
    about: "About",
    career: "Credentials",
    media: "Media",
    referral: "Referrals",
  };

  const handleAvatarSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
    setIsEditingImage(true);
  };

  const handleSaveAvatar = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("picture", selectedFile);

    try {
      setIsSaving(true);

      const res = await updateUserProfile({ picture: selectedFile });

      updateUser(res.user);

      setIsEditingImage(false);
      setPreview(null);
      setSelectedFile(null);

      // ✅ SUCCESS MODAL
      setStatusModal({
        open: true,
        type: "success",
        message: "Profile Updated",
        subtext: "Your profile picture has been updated successfully.",
      });
    } catch (err) {
      console.error(err);
      setStatusModal({
        open: true,
        type: "error",
        message: "Update Failed",
        subtext: "Something went wrong. Please try again.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      {/* HEADER CARD */}
      <div className="account-profile-card">
        <div className="img-account-profile-header">
          <div className="profile-user">
            <div className="profile-avatar-wrapper">
              <img src={avatarSrc} className="profile-avatar" />

              {!isEditingImage ? (
                <>
                  <input
                    type="file"
                    accept="image/*"
                    id="avatarUpload"
                    hidden
                    onChange={handleAvatarSelect}
                  />
                  <label htmlFor="avatarUpload" className="avatar-upload-btn">
                    ✏️ Edit
                  </label>
                </>
              ) : (
                <button
                  className="avatar-upload-btn"
                  onClick={handleSaveAvatar}
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <span className="spinner"></span>
                  ) : (
                    <>
                      <img
                        // src="/images/save-icon.png"
                        alt="a"
                        className="btn-icon"
                      />
                      Save
                    </>
                  )}
                </button>
              )}
            </div>

            <div className="profile-user-info">
              <h3>
                {user?.firstName} {user?.lastName}
              </h3>
              <p className="avatar-user-id">{userIdentity}</p>
            </div>
          </div>

        </div>

        <BadgePanel user={user} />
      </div>

      {/* TABS */}
      <div className="profile-tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => setActiveTab(tab)}
          >
            {tabLabels[tab]}
          </button>
        ))}
      </div>

      {/* SECTIONS */}
      {activeTab === "about" && (
        <AboutSection setStatusModal={setStatusModal} />
      )}
      {activeTab === "career" && (
        <CareerSection setStatusModal={setStatusModal} />
      )}
      {activeTab === "media" && (
        <MediaSection setStatusModal={setStatusModal} />
      )}
      {activeTab === "referral" && (
        <ReferralSection setStatusModal={setStatusModal} />
      )}

      {/* <StatusModal
        open={statusModal.open}
        type={statusModal.type}
        message={statusModal.message}
        subtext={statusModal.subtext}
        onClose={() => setStatusModal({ ...statusModal, open: false })}
      /> */}
    </div>
  );
};

export default ProfileTab;
